import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-modern">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <span className="brand-text">
                            <span className="brand-tag">Tag</span><span className="brand-po">po</span>
                        </span>
                        <p className="footer-tagline">{t('welcome_subtitle')}</p>
                    </div>

                    <div className="footer-links">
                        <div className="footer-section">
                            <h4>{t('home')}</h4>
                            <ul>
                                <li><Link to="/events">{t('events')}</Link></li>
                                <li><Link to="/videos">{t('videos')}</Link></li>
                                <li><Link to="/login">{t('nav_login')}</Link></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h4>Legal</h4>
                            <ul>
                                <li><Link to="/privacy-policy">{t('privacy_policy_link')}</Link></li>
                                <li><Link to="/terms-of-use">{t('terms_of_use_link')}</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} Tagpo. {t('footer_rights')}</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
